module.exports = __webpack_public_path__ + "img/ring_y_skip_0_1@2x.713072a6.png";